import { Box } from "@mui/material";
import cart from "../../../../../assets/icons/cart-green.svg";
import MDTypography from "../../../../../components/MDTypography";
import flecha from "../../../../../assets/icons/flecha.svg";
import * as React from "react";
import MDBox from "../../../../../components/MDBox";
import { Done } from "@mui/icons-material";
import document from "../../../../../assets/icons/document-green.svg";
import payment from "../../../../../assets/images/payment.png";
import track from "../../../../../assets/icons/delivery-track.svg";
import checked from "../../../../../assets/icons/checked-grey.svg";
import MDButton from "../../../../../components/MDButton";
import { useStores } from "../../../../../models";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "../share-quote-section/CheckoutForm";
import AddBaseModal from "../../../../../components/add-base-modal/AddBaseModal";
import { showMessage, useApi } from "../../../../../services/helpers";
import { useParams } from "react-router-dom";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "pk_test_your_publishable_key");

export const PaymentSectionDone = ({ order, onPaymentSuccess, loading, setLoading }) => {
  const api = useApi();
  const rootStore = useStores();
  const { loginStore } = rootStore;
  const { id: projectId } = useParams();
  const [openPaymentModal, setOpenPaymentModal] = React.useState(false);
  const [clientSecret, setClientSecret] = React.useState(null);
  const [fetchingIntent, setFetchingIntent] = React.useState(false);

  const isEligibleBuyer =
    loginStore?.id === order?.buyer?.id ||
    (order?.buyer?.is_projectmanager && loginStore.isProjectManager);

  const handleOpenPayment = async () => {
    if (!isEligibleBuyer) return;
    setFetchingIntent(true);
    try {
      const result = await api.createPaymentIntent(projectId, {}, order.id);
      if (result.kind === "ok") {
        setClientSecret(result.data.client_secret);
        setOpenPaymentModal(true);
      } else {
        const d = result.errors ?? result.data;
        const msg = typeof d === 'string' ? d
          : Array.isArray(d) ? d[0]
          : d?.detail || d?.non_field_errors?.[0]
          || (d && typeof d === 'object' ? Object.values(d).flat()[0] : null)
          || "Payment setup failed. Please try again.";
        showMessage(msg, 'warning');
      }
    } finally {
      setFetchingIntent(false);
    }
  };

  const handlePaymentSuccess = () => {
    setOpenPaymentModal(false);
    setLoading(true);
    api.confirmPayment(projectId, order.id).handle({
      onSuccess: () => onPaymentSuccess?.(),
      errorMessage: "Error confirming payment",
      onFinally: () => setLoading(false),
    });
  };

  return (
    <>
      {/* Shopping Cart — completed */}
      <MDBox
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        borderRadius={"xl"}
        p={2}
        border={"2px solid #81D61E"}
        sx={{ height: "58px" }}
      >
        <MDBox display={"flex"} alignItems={"center"} gap={1}>
          <Box component={"img"} src={cart} alt={"cart"} sx={{ width: 24, height: 24 }} />
          <MDTypography variant={"h6"}>Shopping Cart</MDTypography>
        </MDBox>
        <Done sx={{ color: "#81D61E", width: 25, height: 25 }} />
      </MDBox>

      <MDBox display={"flex"} justifyContent={"center"}>
        <Box component={"img"} src={flecha} alt={"flecha"} sx={{ width: 24, height: 24 }} />
      </MDBox>

      {/* Contract — completed */}
      <MDBox
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        borderRadius={"xl"}
        p={2}
        border={"2px solid #81D61E"}
        sx={{ height: "58px" }}
      >
        <MDBox display={"flex"} alignItems={"center"} gap={1}>
          <Box component={"img"} src={document} alt={"document"} sx={{ width: 24, height: 24 }} />
          <MDTypography variant={"h6"}>Contract</MDTypography>
        </MDBox>
        <Done sx={{ color: "#81D61E", width: 25, height: 25 }} />
      </MDBox>

      <MDBox display={"flex"} justifyContent={"center"}>
        <Box component={"img"} src={flecha} alt={"flecha"} sx={{ width: 24, height: 24 }} />
      </MDBox>

      {/* Payment — active */}
      <MDBox border={"2px solid #81D61E"} p={2} borderRadius={"xl"}>
        <MDBox
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
          gap={1}
          pb={1}
          borderBottom={"1px solid #DBDBDB"}
        >
          <MDBox display={"flex"} alignItems={"center"} gap={1}>
            <Box component={"img"} src={payment} alt={"payment"} sx={{ width: 24, height: 24 }} />
            <MDTypography variant={"h6"}>Payment</MDTypography>
          </MDBox>
        </MDBox>

        <MDBox display={"flex"} justifyContent={"center"} pt={2}>
          {isEligibleBuyer ? (
            <MDButton
              color={"primary"}
              loading={fetchingIntent || loading}
              disabled={fetchingIntent || loading}
              onClick={handleOpenPayment}
            >
              Send Payment
            </MDButton>
          ) : (
            <MDTypography variant={"body2"} color={"text"}>
              Awaiting buyer payment
            </MDTypography>
          )}
        </MDBox>
      </MDBox>

      <MDBox display={"flex"} justifyContent={"center"}>
        <Box component={"img"} src={flecha} alt={"flecha"} sx={{ width: 24, height: 24 }} />
      </MDBox>

      {/* Fulfillment — upcoming */}
      <MDBox
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        borderRadius={"xl"}
        p={2}
        border={"2px solid #DBDBDB"}
        sx={{ height: "58px" }}
      >
        <MDBox display={"flex"} alignItems={"center"} gap={1}>
          <Box component={"img"} src={track} alt={"track"} sx={{ width: 24, height: 24 }} />
          <MDTypography variant={"h6"}>Fulfillment</MDTypography>
        </MDBox>
      </MDBox>

      <MDBox display={"flex"} justifyContent={"center"}>
        <Box component={"img"} src={flecha} alt={"flecha"} sx={{ width: 24, height: 24 }} />
      </MDBox>

      {/* Complete — upcoming */}
      <MDBox
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        borderRadius={"xl"}
        p={2}
        border={"2px solid #DBDBDB"}
        sx={{ height: "58px" }}
      >
        <MDBox display={"flex"} alignItems={"center"} gap={1}>
          <Box component={"img"} src={checked} alt={"checked"} sx={{ width: 24, height: 24 }} />
          <MDTypography variant={"h6"}>Complete</MDTypography>
        </MDBox>
      </MDBox>

      {/* Stripe Payment Modal */}
      <AddBaseModal
        open={openPaymentModal}
        handleClose={() => setOpenPaymentModal(false)}
        showActions={false}
        modalContainer={{ width: 650 }}
      >
        <MDBox p={3} minHeight={300}>
          {clientSecret && (
            <Elements stripe={stripePromise} options={{ clientSecret }}>
              <CheckoutForm clientSecret={clientSecret} onSuccess={handlePaymentSuccess} />
            </Elements>
          )}
        </MDBox>
      </AddBaseModal>
    </>
  );
};
